import { render, staticRenderFns } from "./fallible.vue?vue&type=template&id=2e16b876&scoped=true"
import script from "./fallible.vue?vue&type=script&lang=js"
export * from "./fallible.vue?vue&type=script&lang=js"
import style0 from "./fallible.vue?vue&type=style&index=0&id=2e16b876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e16b876",
  null
  
)

export default component.exports